import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainGuard } from './main.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/records' },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomeModule),
    canActivate: [MainGuard],
    data: { disableMenu: false }
  },
  {
    path: 'records',
    loadChildren: () => import('./pages/records/records.module').then(m => m.RecordsModule),
    canActivate: [MainGuard],
    data: { disableMenu: false }
  },
  {
    path: 'online-reception',
    loadChildren: () => import('./pages/online-veterinary/reception/reception.module').then(m => m.ReceptionModule),
    canActivate: [MainGuard],
    data: { disableMenu: false }
  },
  {
    path: 'online-profile',
    loadChildren: () => import('./pages/online-veterinary/online-profile/online-profile.module').then(m => m.OnlineProfileModule),
    canActivate: [MainGuard],
    data: { disableMenu: false }
  },
  {
    path: 'hospital',
    loadChildren: () => import('./pages/hospital/hospital.module').then(m => m.HospitalModule),
    canActivate: [MainGuard],
    data: { disableMenu: false }
  },
  {
    path: 'my-appointments',
    loadChildren: () => import('./pages/appointments/appointments.module').then(m => m.AppointmentsModule),
    canActivate: [MainGuard],
    data: { disableMenu: false }
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings-company/settings-company.module').then(m => m.SettingsCompanyModule),
    canActivate: [MainGuard],
    data: { disableMenu: false }
  },
  {
    path: 'clients',
    loadChildren: () => import('./pages/clients/clients.module').then(m => m.ClientsModule),
    canActivate: [MainGuard],
    data: { disableMenu: false }
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
    data: { disableMenu: true }
  },
  {
    path: 'ai-chat',
    loadChildren: () => import('./pages/ai-chat/ai-chat.module').then(m => m.AIChatModule),
    data: { 
      disableMenu: true,
      disableFooter: true,
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
